

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 80 80","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","class":[styles && styles["icon__svg"] || "icon__svg",styles && styles["icon__svg--pause"] || "icon__svg--pause"].join(' '),"fill":"currentColor","width":"80","height":"80"}, rest), [h('undefined', {}, []), h('title', {}, ["Pause"]), h('desc', {}, ["Created with Sketch."]), h('g', {"id":"svg-pause-2b3q-3B","stroke":"none","stroke-width":"1"}, [h('path', {"d":"M9,0 L31,0 C31.5522847,-1.01453063e-16 32,0.44771525 32,1 L32,79 C32,79.5522847 31.5522847,80 31,80 L9,80 C8.44771525,80 8,79.5522847 8,79 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z M49,0 L71,0 C71.5522847,-1.01453063e-16 72,0.44771525 72,1 L72,79 C72,79.5522847 71.5522847,80 71,80 L49,80 C48.4477153,80 48,79.5522847 48,79 L48,1 C48,0.44771525 48.4477153,1.01453063e-16 49,0 Z"}, [])])]);
};

        